import URLS from "@/constants/api";
import { get_2 } from "./api";

export const downloadIntakeCsvAPI = async () => {
  const response = await get_2(URLS.DOWNLOAD_INTAKES);
  return response;
};
